<template>
  <td
    :class="{ 'is-empty': isEmpty }"
    :colspan="colspan"
  >
    <template v-if="!isEmpty">
      {{ cellValue || '&mdash;' }}
    </template>
  </td>
</template>

<script>
  /**
   * A styled table cell with a background pattern or the value based on various props.
   *
   * @vuedoc
   * @exports Rates/TdValue
   * @category Components
   */
  export default {
    name: 'RateTdValue',
    props: {
      cellData: {
        type: Object,
        required: true,
      },
      colspan: {
        type: Number,
        default: 1,
      },
    },
    computed: {
      /**
       * Evaluate the cell data value to return a parsed float or empty string to be used in the template.
       *
       * @returns {string}
       */
      cellValue() {
        return this.cellData.value && typeof this.cellData.value === 'number'
          ? parseFloat(this.cellData.value).toFixed(3)
          : '';
      },
      /**
       * Evaluate the cellData object for length to determine its emptiness.
       *
       * @returns {boolean}
       */
      isEmpty() {
        return !(Object.keys(this.cellData).length);
      },
    },
  };
</script>

<style scoped lang="scss">
  td {
    border: 1px solid $tf-light-gray;
    padding: 15px 20px;

    &.is-empty {
      /* https://www.coffee-break-designs.com/labs/svg_stripe_generator/ */
      background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxkZWZzPjxwYXR0ZXJuIGlkPSJwYXR0ZXJuX3F4UUNPMSIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgd2lkdGg9IjQuNSIgaGVpZ2h0PSI0LjUiIHBhdHRlcm5UcmFuc2Zvcm09InJvdGF0ZSg0NSkiPjxsaW5lIHgxPSIwIiB5PSIwIiB4Mj0iMCIgeTI9IjQuNSIgc3Ryb2tlPSIjQjRCNEI0IiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPiA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI3BhdHRlcm5fcXhRQ08xKSIgb3BhY2l0eT0iMSIvPjwvc3ZnPg==');
      background-repeat: repeat;
    }
  }
</style>
